import { render, staticRenderFns } from "./GoIn.vue?vue&type=template&id=c0f5d77e&scoped=true"
import script from "./GoIn.vue?vue&type=script&lang=js"
export * from "./GoIn.vue?vue&type=script&lang=js"
import style0 from "./GoIn.vue?vue&type=style&index=0&id=c0f5d77e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f5d77e",
  null
  
)

export default component.exports